export default {
    Account: {
        application_addresses: 'Adreslerim',
        application_invoice_info: 'Fatura Bilgilerim',
        application_orders: 'Siparişlerim',
    },
    AddressClosest: {
        info_sheet_title: 'Konumuna daha yakın bir adres mevcut!',
        info_sheet_description:
            'Bulunduğun konuma daha yakın {{address}} adında bir adresin mevcut. Bu adresi kullanmak\nister misin?',
        info_sheet_accept_button: 'En Yakın Adresi Kullan',
        info_sheet_reject_button: 'Mevcut Adres İle Devam Et',
        alert_error_title: 'Hay Aksi!',
        alert_error_message:
            'Maalesef Üye İş Yeri, seçtiğin adrese hizmet vermemektedir',
        alert_error_action_button: 'Başka Adres Seç',
        alert_error_action_reject_button: 'Vazgeç',
    },
    AddressCreate: {
        route_header_title: 'Yeni Adres Ekle',
        route_header_description:
            'Ürün listelerine ulaşmak için adres ekleyebilir ya da adresleri düzenleyebilirsiniz.',
        success_toast_message: 'Adresin başarıyla eklendi',
        check_box_title: 'Varsayılan adresim olarak belirle',
        form_label_address_title: 'Adres Başlığı',
        form_label_street: 'Sokak/Cadde',
        form_label_building_number: 'Bina No',
        form_label_floor: 'Kat',
        form_label_door_number: 'Daire No',
        form_label_directions: 'Adres Tarifi',
        form_placeholder_first_name: 'Adınız',
        form_placeholder_last_name: 'Soyadınız',
        form_placeholder_phone: 'Cep Telefonu',
        row_title_contact_information: 'İLETİŞİM BİLGİLERİ',
        dropdown_field_label: 'İl, İlçe, Mahalle',
        dropdown_field_city_modal_header_title: 'İl Seç',
        dropdown_field_city_description:
            'Adres için il, ilçe ve mahalle seçimi',
        dropdown_field_district_modal_header_title: 'İlçe Seç',
        dropdown_field_neighborhoods_modal_header_title: 'Mahalle Seç',
        submit_button: 'Kaydet',
        alert_error_title: 'Hay Aksi!',
        alert_error_message:
            'Maalesef Üye İş Yeri, seçtiğin adrese hizmet vermemektedir',
        alert_error_action_button: 'Başka Adres Seç',
        alert_error_action_reject_button: 'Vazgeç',
    },
    AddressUpdate: {
        route_header_title: 'Adresi Güncelle',
        route_header_description:
            'Adres bilgilerini buradan güncelleyebilirsin.',
        success_toast_message: 'Adresin başarıyla güncellendi',
        submit_button: 'Kaydet',
    },
    Addresses: {
        right_info_title: 'Adreslerim nasıl çalışır?',
        right_info_description:
            'Adreslerim alanında, Adrese Teslim siparişleriniz için teslimat adreslerinizi kaydedebilirsiniz. Adreslerinizi daha kolay tanıyabilmek için isim verebilirsiniz. Bir adres eklerken il, ilçe, mahalle, açık adres, bina numarası, kapı numarası ve kat bilgilerini girebilirsiniz. Eklediğiniz adreslerden birini ön tanımlı adres olarak belirleyebilir, mevcut adreslerinizi silebilir veya yeni adresler ekleyebilirsiniz. Sistemde en fazla 10 adres kaydedebilirsiniz.',
        address_list_section_title: 'Kayıtlı Adreslerim',
        address_list_section_bar_title: 'Adreslerim',
        address_list_section_bar_description:
            'Ürün listesine ulaşmak için adres ekleyebilir ya da silebilirsin',
    },
    AddressMap: {
        route_header_title: 'Adresini Haritadan Seç',
        route_header_description:
            'Hızlı ve doğru adres eklemek için konumunuzu harita üzerinden belirleyin.',
        submit_location_button: 'Bu Konumu Kullan',
        search_field_placeholder: 'Mahalle, sokak veya cadde ara',
    },
    AddressList: {
        success_toast_message: 'Adres bilgin başarıyla silindi',
        alert_delete_address_title: 'Adres Silme İşlemi',
        alert_delete_address_message:
            'Seçilen adresi silmek istediğine emin misin?',
        alert_delete_action_button: 'Adresi Sil',
        alert_delete_action_cancel_button: 'Vazgeç',
        list_empty_component_title: 'Adres Bulunamadı',
        list_empty_component_description:
            'Kayıtlı adresin olduğunda burada listelenecektir',
        address_list_footer_button: 'Yeni Adres Ekle',
        toast_provider_error_message: 'Maksimum adres sınırına ulaşıldı ',
        address_edit_chip_label: 'Düzenle',
        address_action_sheet_title: 'Adresi Düzenle',
        address_action_sheet_message:
            'Bu adres üzerinde işlem yapmak için aşağıdaki seçeneklerden birini seçebilirsin.',
        address_action_update_button: 'Adres Bilgilerini Güncelle',
    },
    InvoiceInfos: {
        section_bar_title: 'Fatura Bilgilerim',
        section_title: 'Kayıtlı Fatura Bilgilerim',
        section_bar_description:
            'Fatura bilgilerini oluşturabilir, seçebilir ve güncelleyebilirsin.',
        right_info_title: 'Fatura Bilgilerim nasıl çalışır?',
        right_info_description:
            'Fatura Bilgilerim alanında, faturalandırma için kullanacağınız bireysel ya da kurumsal bilgilerinizi kaydedebilirsiniz. Her fatura bilgisine bir başlık verip, ad-soyad, iletişim, vergi bilgileri ve adres detaylarını girebilirsiniz. Kayıtlı fatura bilgilerinizden birini varsayılan olarak belirleyebilir, mevcut kayıtlarınızı silebilir veya yenisini ekleyebilirsiniz.',
        list_empty_component_title: 'Kayıtlı Fatura Bilgisi Bulunamadı',
        list_empty_component_description:
            'Kayıtlı fatura bilgilerin olduğunda burada listelenecektir',
        list_footer_button: 'Yeni Fatura Bilgisi Ekle',
        edit_chip_label: 'Düzenle',
        toast_provider_error_message:
            'Maksimum fatura bilgisi sınırına ulaşıldı',
    },
    InvoiceInfoActions: {
        action_sheet_title: 'Fatura Bilgisini Düzenle',
        action_sheet_message:
            'Bu fatura bilgisi üzerinde işlem yapmak için aşağıdaki seçeneklerden birini seçebilirsin.',
        action_update_button: 'Fatura Bilgilerini Güncelle',
        alert_delete_title: 'Fatura Bilgisi Silme İşlemi',
        alert_delete_message:
            'Seçilen fatura bilgisini silmek istediğine emin misin?',
        alert_delete_action_button: 'Fatura Bilgisini Sil',
        alert_delete_action_cancel_button: 'Vazgeç',
        delete_success_toast_message: 'Fatura bilgin başarıyla silindi',
    },
    InvoiceInfoCreate: {
        route_header_title: 'Yeni Fatura Bilgisi Ekle',
        route_header_description:
            'Faturalandırma için kullanılacak bireysel ya da kurumsal fatura bilgilerini buradan ekleyebilirsin.',
        success_toast_message: 'Fatura bilgin başarıyla eklendi',
        check_box_title: 'Varsayılan fatura olarak belirle.',
        row_title_contact_information: 'İLETİŞİM & FATURA BİLGİLERİ',
        customer_personal_label: 'Bireysel',
        customer_corporate_label: 'Kurumsal',
        form_label_title: 'Fatura Başlığı',
        form_label_street: 'Sokak/Cadde',
        form_label_building_number: 'Bina No',
        form_label_floor: 'Kat',
        form_label_door_number: 'Daire No',
        form_placeholder_title: 'Başlık Yazınız',
        form_placeholder_first_name: 'Adınız',
        form_placeholder_last_name: 'Soyadınız',
        form_placeholder_phone: 'Cep Telefonu',
        form_placeholder_email: 'E-Posta',
        form_placeholder_id_number: 'TCKN',
        form_placeholder_company_name: 'Firma Ünvanı',
        form_placeholder_tax_number: 'VKN',
        form_placeholder_tax_office: 'Vergi Dairesi',
        submit_button: 'Kaydet',
    },
    InvoiceInfoUpdate: {
        route_header_title: 'Fatura Bilgisi Düzenle',
        route_header_description:
            'Fatura bilgilerini buradan güncelleyebilirsin.',
        success_toast_message: 'Fatura bilgin başarıyla güncellendi',
        submit_button: 'Kaydet',
    },
    Invoices: {
        content_header_title: 'Faturalarım',
        content_header_description:
            'Tüm fatura hareketlerine buradan kolayca ulaşabilirsin.',
        search_placeholder: 'Ara',
        empty_sheet_title: 'Fatura Yok',
        empty_sheet_description: 'Sana özel herhangi bir fatura bulunamadı',
    },
    InvoiceDetail: {
        route_header_title: 'Fatura',
        pdf_toast_error_message: 'PDF yüklenirken bir hata oluştu',
        error_title: 'Hata',
        error_description:
            'Faturanız şu anda indirilemiyor. Lütfen daha sonra tekrar deneyin veya müşteri hizmetleri ile iletişime geçin',
    },
    InvoicesFilter: {
        route_header_title: 'Fatura Filtrele',
        content_description:
            'Gerekli filtrelemeleri yap ve sonuçlara kolayca ulaş',
        form_final_total_from_label: 'Minimum Tutar',
        form_final_total_to_label: 'Maksimum Tutar',
        form_start_date_label: 'Başlangıç Tarihi',
        form_end_date_label: 'Bitiş Tarihi',
        submit: 'Sonuçları Göster',
    },
    UserFallback: {
        passive_title: 'Hesabınız Pasif Durumda',
        passive_description:
            'Hesabınız pasife alındığı için cüzdan detayını görüntüleyemiyorsunuz.',
        blacklisted_title: 'Hesap Erişimi Kısıtlandı',
        blacklisted_description:
            'Hesabınız güvenlik kontrolleri kapsamında kısıtlanmıştır, destekle iletişime geçebilirsiniz.',
    },
}
